import { render, staticRenderFns } from "./BalanceReport.vue?vue&type=template&id=6017c5e8&scoped=true&"
import script from "./BalanceReport.vue?vue&type=script&lang=js&"
export * from "./BalanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6017c5e8",
  null
  
)

export default component.exports